export default __webpack_public_path__ + "5e8d83f763b19c2dd7fe7e80186e2442.png";